import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const field = "mt-1.5 h-11 focus-visible:ring-[#1FBF8F]";

export const JoinForm = () => {
  const { join } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ role: "consultor", name: "", email: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const s = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await join(f); navigate("/inicio"); }
    catch (e2) { setErr(apiErr(e2.response?.data?.detail) || e2.message); }
    finally { setLoading(false); }
  };

  return (
    <>
      <h2 className="font-extrabold tracking-tight text-2xl text-[#13224A] mb-1">Registar-me na minha agência</h2>
      <p className="text-sm text-slate-500 mb-6">Use o email da sua agência. Com um email pessoal, peça um convite à Direção.</p>
      {err && <div className="mb-4 text-sm bg-red-50 text-red-700 border border-red-200 rounded-lg px-3 py-2" data-testid="join-error">{err}</div>}
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label>A sua função</Label>
          <div className="grid grid-cols-2 gap-2 mt-1.5">
            {[["consultor", "Consultor"], ["gestor", "Gestor processual"]].map(([k, l]) => (
              <button type="button" key={k} onClick={() => setF({ ...f, role: k })} data-testid={`join-role-${k}`}
                className={`py-2 rounded-lg border text-sm transition-colors ${f.role === k ? "border-[#13224A] bg-[#13224A] text-white" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`}>{l}</button>
            ))}
          </div>
        </div>
        <div><Label>O seu nome</Label><Input value={f.name} onChange={s("name")} required className={field} data-testid="join-name" /></div>
        <div><Label>Email</Label><Input type="email" value={f.email} onChange={s("email")} required className={field} data-testid="join-email" placeholder="nome@agencia.pt" /></div>
        <div>
          <Label>Palavra-passe</Label>
          <Input type="password" value={f.password} onChange={s("password")} required minLength={7} className={field} data-testid="join-password" />
          <p className="text-xs text-slate-400 mt-1">Mínimo de 7 caracteres.</p>
        </div>
        <button type="submit" disabled={loading} data-testid="join-submit"
          className="w-full bg-[#13224A] text-white py-3 rounded-full font-semibold hover:bg-[#0D1836] transition-colors disabled:opacity-60">
          {loading ? "A registar…" : "Registar-me"}
        </button>
      </form>
    </>
  );
};
